import Vue from 'vue'
import { Trait, Lifecycle } from 'av-ts'

// Global mixins

export interface NotifOptions {
  context?: 'success' | 'info' | 'warning' | 'error' | 'primary' | 'secondary'
  timeout?: number
}

@Trait
export class EventBus extends Vue {
  private static eventBus = new Vue()

  get eventBus(): Vue {
    return EventBus.eventBus
  }

  emitNotif(msg: string, options?: NotifOptions): void {
    this.eventBus.$emit('notif', msg, options)
  }

  static emitError(err: string): void {
    EventBus.eventBus.$emit('error', err)
  }

  @Lifecycle
  created() {
    // global error handler
    window.onerror = (event) => {
      console.debug('[EventBus] uncaught error:', event)
      EventBus.emitError('Uncaught error: ' + event)
    }
  }
}
